<template>
  <LayoutContent>
    <SectionTitle :label="$t('label.reviewSalon')" />
    <v-card>
      <component
        :is="reviewSteps[currentStep]"
        @stepUp="onStepUp"
        @submit="onSubmit"
        :review="review"
        :branchName="review.branch_name"
        :stylist="stylists[currentStep - 1]"
        :submit="currentStep == stylists.length"
      />
    </v-card>
  </LayoutContent>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import SectionTitle from '@/components/SectionTitle.vue'
import ReviewSalon from '@/components/review/ReviewSalon.vue'
import ReviewStylist from '@/components/review/ReviewStylist.vue'
import LayoutContent from '@/views/layouts/LayoutContent.vue'

export default {
  props: {
    posTransactionId: { required: true }
  },

  components: { ReviewSalon, SectionTitle, LayoutContent },

  data() {
    return {
      currentStep: 0,
      reviewSteps: [ReviewSalon],
      review: {},
      stylists: []
    }
  },

  created() {
    console.log('CREATED', this.posTransactionId)
    this.review = this.getMyReviewSalonStylistToReviewByPosTransId(this.posTransactionId)
    this.stylists = this.review.item
    this.reviewSteps = { ...[...this.reviewSteps, ...this.stylists.map((_) => ReviewStylist)] }
  },

  computed: {
    ...mapState('review', ['salonStylistReviewForm']),
    ...mapGetters('review', ['getMyReviewSalonStylistToReviewByPosTransId'])
  },

  methods: {
    ...mapActions('review', ['createSalonStylistReview']),
    onStepUp() {
      if (this.currentStep == this.stylists.length) {
        if (this.salonStylistReviewForm.reviews.length > 0 && this.salonStylistReviewForm.comments.length > 0) {
          this.onSubmit()
        } else {
          this.$router.push({ name: this.$constants.ROUTE_NAME.SALON_STYLIST_REVIEW_LIST })
        }
      }
      this.currentStep++
    },
    onSubmit() {
      let reviewParams = {
        pos_transaction_id: this.salonStylistReviewForm.posTransId,
        reviews: {
          reviews: this.salonStylistReviewForm.reviews
        },
        comments: {
          comments: this.salonStylistReviewForm.comments
        }
      }
      this.createSalonStylistReview(reviewParams)
      this.$router.push({ name: this.$constants.ROUTE_NAME.SALON_STYLIST_REVIEW_COMPLETE })
    }
  }
}
</script>
